export * from './UIGameEndFooter.tsx';
